import { createContext } from 'react';
import { createPropsContextProvider } from '../../utils/createPropsContextProvider.js';
import { createUseDefinedContext } from '../../utils/hooks/createUseDefinedContext.js';
const listStyleContext = createContext(undefined);
export const ListStyleProvider = createPropsContextProvider(listStyleContext);
export const useListStyle = createUseDefinedContext(listStyleContext, 'Please wrap your component with ListStyleProvider');
//# sourceMappingURL=ListStyleProvider.js.map